export const MEDIA_FOR_POINTER = "(pointer: coarse)";
export const MOBILE_VIEW_BP = 1200;
export const MEDIA_FOR_MOBILE = `screen and (max-width: ${MOBILE_VIEW_BP}px)`;

export const DEVICE_TYPE = {
	MOBILE: "mobile",
	WEB: "web"
};